export const POST_SIGNUP_SMS_CONTEXT_TTL_MS = 30 * 60 * 1000;

export type PromotionalSmsOutcome = "not_presented" | "accepted" | "declined";

export function getPromotionalSmsOutcome(presented: boolean, selected: boolean): PromotionalSmsOutcome {
  if (!presented) return "not_presented";
  return selected ? "accepted" : "declined";
}
